export const DEFAULT_SUBSCRIPTION_FORM_COMPONENT_WIDTH = 200;
